export enum BasePointEnum {
  NO_ID = '',
  NO_FIRST_ALTITUDE = -2,
  NO_ALTITUDE = -3,
}
